import React, { useId } from 'react';

interface TimezoneSelectorProps {
  value?: string;
  onChange: (value: string) => void;
  label?: string;
  helperText?: string;
  className?: string;
}

const COMMON_TIMEZONES: string[] = [
  'UTC',
  'Asia/Manila',
  'Asia/Tokyo',
  'Asia/Singapore',
  'Asia/Shanghai',
  'Asia/Hong_Kong',
  'Asia/Seoul',
  'Asia/Bangkok',
  'Australia/Sydney',
  'Australia/Melbourne',
  'Pacific/Auckland',
  'America/New_York',
  'America/Chicago',
  'America/Denver',
  'America/Los_Angeles',
  'America/Toronto',
  'Europe/London',
  'Europe/Paris',
  'Europe/Berlin',
  'Europe/Madrid',
  'Europe/Rome',
];

export const TimezoneSelector: React.FC<TimezoneSelectorProps & { id?: string }> = ({ value, onChange, label = 'Timezone', helperText, className, id }) => {
  const autoId = useId();
  const selectId = id || `tz-${autoId}`;
  return (
    <div className={className}>
      <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1" htmlFor={selectId}>{label}</label>
      <select
        id={selectId}
        className="block w-full rounded-md border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-800 py-2 px-3 shadow-sm focus:border-indigo-500 focus:outline-none focus:ring-indigo-500 dark:focus:border-blue-500 dark:focus:ring-blue-500 sm:text-sm text-gray-900 dark:text-gray-100"
        value={value || ''}
        onChange={(e) => onChange(e.target.value)}
      >
        <option value="">Select timezone</option>
        {COMMON_TIMEZONES.map(tz => (
          <option key={tz} value={tz}>{tz}</option>
        ))}
      </select>
      {helperText && (
        <p className="mt-1 text-xs text-gray-500 dark:text-gray-400">{helperText}</p>
      )}
    </div>
  );
};

export default TimezoneSelector;
